import { useContext } from 'react';
import {
  MasterDetailContext,
  MasterDetailContextProps,
} from './MasterDetailContext';

export function useMasterDetail<T>(): MasterDetailContextProps<T> | null {
  const context = useContext(MasterDetailContext);
  if (!context) {
    return null;
  }
  return context;
}
